import { BoxIcon, CalendarGreyIcon, ClocckGreyIcon, MessageGreenIcon, OnlineOrderBlackIcon, TelephoneIcon, UserGreyIcon, WallClockIcon } from "../../../../../assets/icons";
import { OrderStatusType, orderStatusTypeToClassName, orderStatusTypeToString } from "../../../../../models/base/OrderStatusType"
import { OrderType } from "../../../../../models/base/OrderType";
import { LiveOrderInfoDTO } from "../../../../../models/shared/response";
import { ToLocalDateTimeString } from "../../../../../utils/dateFormater";
import OrderItemView1 from "./OrderItemView1";


interface OrderInfoView1Props {
    order: LiveOrderInfoDTO;
    handleOrderStatusChange: (orderId: string, newStatus: OrderStatusType) => void;
    handleOrderStatusToNext: (orderId: string) => void;
    listItemOrder?: boolean;
}

const OrderInfoView1: React.FC<OrderInfoView1Props> = ({ order, handleOrderStatusChange, handleOrderStatusToNext, listItemOrder }) => {

    return (
        <div className={`admin-settings-box-div lo-table-order-div ${orderStatusTypeToClassName(order.currentStatus)}`} key={order.id}>
            <div className="lo-table-order-header-div">
                <div className="lo-table-order-header-top-div">
                    <div className="to-table-order-count">Porudzbina #{order.id.slice(0, 8)}</div>
                    <div className={`small-box-div ${orderStatusTypeToClassName(order.currentStatus)}`}>
                        <div className="text-block-12">{orderStatusTypeToString(order.currentStatus)}</div>
                    </div>
                </div>
                <div className="lo-table-order-header-bottom-div">
                    {order.type === OrderType.DineIn && (
                        <div className="lo-table-order-header-bottom">
                            <img loading="lazy" src={WallClockIcon} alt="" className="icon-size-16" />
                            <div className="text-block-39">{Math.floor((new Date().getTime() - new Date(order.createdAt).getTime()) / 60000)} min</div>
                        </div>
                    )}
                    {order.type === OrderType.Pickup && (
                        <div className="lo-table-order-header-bottom">
                            <img loading="lazy" src={CalendarGreyIcon} alt="" className="icon-size-16" />
                            <div className="text-block-39">{ToLocalDateTimeString(order.pickUpAt.toString())}</div>
                        </div>
                    )}
                    {order.type === OrderType.Delivery && (
                        <div className="lo-table-order-header-bottom">
                            <img loading="lazy" src={WallClockIcon} alt="" className="icon-size-16" />
                            <div className="text-block-39">{order.street}, {order.streetNumber}{order.apartment ? `/${order.apartment}` : ""}</div>
                        </div>
                    )}
                    <div className="lo-table-order-header-bottom">
                        <img loading="lazy" src={ClocckGreyIcon} alt="" className="icon-size-16" />
                        <div>{ToLocalDateTimeString(order.createdAt.toString())}</div>
                    </div>
                    <div className="lo-table-order-header-bottom">
                        <img loading="lazy" src={UserGreyIcon} alt="" className="icon-size-16" />
                        <div>{order.fullName}</div>
                    </div>
                    {order.type !== OrderType.DineIn && (
                        <div className="lo-table-order-header-bottom">
                            <img loading="lazy" src={TelephoneIcon} alt="" className="icon-size-16" />
                            <div>{order.phoneNumber}</div>
                        </div>
                    )}
                    {!listItemOrder && (
                        <div className="lo-table-order-header-bottom">
                            <img loading="lazy" src={BoxIcon} alt="" className="icon-size-16" />
                            <div>{order.items.length}</div>
                        </div>
                    )}
                </div>
            </div>

            <div className="lo-table-order-product-list-block">
                <div className="lo-table-order-product-list-div">

                    {order.items.map(item => (

                        <OrderItemView1
                            key={item.id}
                            item={item}
                        />
                    ))}
                </div>
            </div>

            {order.description && (
                <div className="lo-table-order-message-div">
                    <div className="lo-table-order-message-image-div">
                        <img loading="lazy" src={MessageGreenIcon} alt="" className="icon-size-16" />
                    </div>
                    <div>
                        <div className="description-text fs-12">Napomena za porudžbinu:</div>
                        <div className="text-block-13">{order.description}</div>
                    </div>
                </div>
            )}

            <div className="lo-table-order-total-price">
                <div>Ukupno:</div>
                <div>{order.items.reduce((total, item) => total + item.productVariantPrice * item.quantity, 0)} RSD</div>
            </div>

            <div className="lo-table-order-status-div">
                <div className="form-block-4 w-form">
                    <form className="modal-form">
                        <div className="description-text">
                            Status porudžbine<br />
                        </div>
                        <div className="div-block-16">
                            <select
                                className="form-select auto-width w-select"
                                value={order.currentStatus}
                                onChange={(e) =>
                                    handleOrderStatusChange(order.id, Number(e.target.value) as OrderStatusType)
                                }
                            >
                                <option value={OrderStatusType.Ordered}>Poručeno</option>
                                <option value={OrderStatusType.Recived}>Primljeno</option>
                                <option value={OrderStatusType.Served}>Posluženo</option>
                                <option value={OrderStatusType.Bill}>Račun</option>
                                <option value={OrderStatusType.Paid}>Plaćeno</option>
                                <option value={OrderStatusType.Cancelled}>Otkazano</option>
                            </select>
                            <div className="button-primary order-next-status" onClick={() => handleOrderStatusToNext(order.id)}>
                                <div>&gt;</div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

        </div>
    );
};

export default OrderInfoView1;